import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';
import guttersJson from '../assets/gutters-sk.json';
import {
    MDBCol,
    MDBRow,
    MDBCard,
    MDBCardImage,
    MDBCardBody,
    MDBCardText,
} from 'mdb-react-ui-kit';

const imgHref = (process.env.REACT_APP_ENV === "dev") ? 'https://testapi.bramac.cz/prilohy/cenovanabidka/gutter/' : '../prilohy/cenovanabidka/gutter/';
const gutterColorMap = {
    tehlovocervena: "tehlovocervena",
    kralovska_cervena: "tehlovocervena",
    lavova_cervena: "tehlovocervena",
    rezna: "tehlovocervena",

    cervenohneda: "cervenohneda",
    kralovska_bordeaux: "cervenohneda",
    engoba_medena: "cervenohneda",
    antik: "cervenohneda",
    magico: "cervenohneda",

    tmavohneda: "tmavohneda",
    engoba_hneda: "tmavohneda",
    kralovska_mocca: "tmavohneda",
    umbra: "tmavohneda",
    montano: "tmavohneda",
    glazura_tmavohneda: "tmavohneda",

    antracit: "antracitova",
    engoba_antracitova: "antracitova",
    zinkove_seda: "antracitova",
    glazura_seda: "antracitova",
    granit_metalic: "antracitova",
    mocca_metalic: "antracitova",

    cerna: "cerna",
    bridlicove_cerna: "cerna",
    glazura_cerna: "cerna",
    ebenove_cerna: "cerna",
    ebenove_cierna: "cerna",
};


function GuttersView(props) {
    return (
        <MDBRow className='mt-3'>
            {props.guttersColors?.map(color => {
                const selectedMark = (props.chosenOkap.barva === color.barva) ? "" : "d-none"
                return (
                    <MDBCol size='4' lg='2' key={color.modelNazev + color.barvaNazev}>
                        <MDBCard className='h-100' background='light' alignment='center'
                            onClick={() => { props.setChosenOkap(color); }}>
                            <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                            <MDBCardImage
                                src={imgHref + "/okapy-vicko-" + color.barva + ".png"}
                                alt='&empty;'
                                position='top'
                                className='p-1'
                            />
                            <MDBCardBody className='p-1 mb-2'>
                                <MDBCardText>{color.barvaNazev}</MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                )
            })}
        </MDBRow>
    );
}

function Gutters(props) {
    const [gutters, setGutters] = useState();
    const [chosenOkap, setChosenOkap] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const didMount = useRef(false);
    const didLoad = useRef(false);

    useEffect(() => {
        if (didLoad.current) return;
        let isMounted = true;
        const controller = new AbortController();

        const getOkapy = async () => {
            try {
                const response = await axiosPrivate.get('/okapy/get', {
                    signal: controller.signal
                }, { maxRedirects: 0 });
                didLoad.current = true;
                isMounted && setGutters(response.data);
                setChosenOkap(response.data.find(okap => okap.model === "Stabicor M" && okap.barva === "cerna"));
            } catch (err) {
                //setGutters(guttersJson);
                //setChosenOkap(guttersJson.find(okap => okap.model === "Stabicor M" && okap.barva === "cerna"));
            }
        }

        if (auth?.accessToken !== undefined) {
            getOkapy();
        } else {
            setGutters(guttersJson);
            setChosenOkap(guttersJson.find(okap => okap.model === "Stabicor M" && okap.barva === "cerna"));
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [auth]);

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        props.step.data = { chosenOkap }

    }, [chosenOkap, gutters]);

    useEffect(() => {
        var selectedGutterColor = gutterColorMap[props.selectedCoveringColor] || "cerna";
        setChosenOkap(guttersJson.find(okap => okap.model === "Stabicor M" && okap.barva === selectedGutterColor));
    }, [props.selectedCoveringColor]);

    let guttersColors = gutters?.filter(okap => okap.model === "Stabicor M");

    return (
        <GuttersView guttersColors={guttersColors} chosenOkap={chosenOkap} setChosenOkap={setChosenOkap} {...props} />
    );

}

export default Gutters;
